var moduleMap = {
	"./TermFormBuilder": () => {
		return Promise.all([__webpack_require__.e(7514), __webpack_require__.e(1851), __webpack_require__.e(2033), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(5674), __webpack_require__.e(7403), __webpack_require__.e(4468)]).then(() => (() => ((__webpack_require__(19019)))));
	},
	"./FingerprintCapture": () => {
		return Promise.all([__webpack_require__.e(7514), __webpack_require__.e(1851), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(7403), __webpack_require__.e(2171)]).then(() => (() => ((__webpack_require__(73223)))));
	},
	"./FingerprintPanel": () => {
		return Promise.all([__webpack_require__.e(7514), __webpack_require__.e(1851), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(7403), __webpack_require__.e(3436)]).then(() => (() => ((__webpack_require__(1928)))));
	},
	"./PatientGeneralInformationForm": () => {
		return Promise.all([__webpack_require__.e(7514), __webpack_require__.e(1851), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(7403), __webpack_require__.e(1891)]).then(() => (() => ((__webpack_require__(30220)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});